export const INQUIRY_AUCTION_CREATE_PAGE_PATH = '/auction/inquiry/create'

export const INQUIRY_AUCTION_LIST_PAGE_PATH = '/auction/inquiry/list'
